import React, { useState, useEffect } from 'react';
import { Button, Col, Row, Offcanvas, Image } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import RHFTextField from '../../FunctionalComponent/FormElement/RHTextField';
import FormProvider from '../../FunctionalComponent/FormElement/FormProvider';
import RHSelectField from '../../FunctionalComponent/FormElement/RHSelectField';
import { useDispatch } from 'react-redux';
import ColorPicker from 'react-pick-color';
import * as Yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { showSnackbar } from "../../Redux/SnakbarSlice"
import { useCreate_Update_colorMutation, useGetColorDataMutation } from '../../Redux/ColorSlice';

function ColorAdd(props) {
    const { colourGroupname, setColoradd, ColorID, coloradd, showCoupons, setShowCoupons, showCouponDetails } = props;
    const [CreateUpdateColorFunc] = useCreate_Update_colorMutation();
    const [GetColorDataFunc] = useGetColorDataMutation()
    const dispatch = useDispatch();
    const [colorpicker, setColorpicker] = useState(false);
    let initialState = {
        name: '',
        slug: '',
        hexCode: '',
        colourGroupName: '',
        status: ''
    };
    const schema = Yup
        .object({
            name: Yup
                .string()
                .required()
                .strict(true),
            // .trim('White spaces before and after are not allow'),
            slug: Yup
                .string()
                .required()
                .strict(true),
            // .trim('White spaces before and after are not allow'),
            hexCode: Yup
                .string()
                .required()
                .strict(true),
            // status: Yup.string().required(),
            status: Yup.string().required('Status is required'),
        })
        .required();
    const methods = useForm({
        resolver: yupResolver(schema),
        defaultValues: initialState,
        mode: 'all',
    });
    const {
        reset,
        setError,
        handleSubmit,
        setValue,
        getValues,
        getFieldState,
        clearErrors,
        watch,
        formState: { errors },
    } = methods;

    const onSubmit = () => {
        const data = getValues();
        CreateUpdateColorFunc({ ...data, colourGroupName: colourGroupname, id: ColorID })
            .then((res) => {
                if (res?.payload?.data?.statusCode == 201 || 200) {
                    setColoradd(false)
                } else {
                    dispatch(showSnackbar({ severity: 'error', message: res?.payload?.data?.message }))
                }
            })
    }
    useEffect(() => {
        if (ColorID) {
            GetColorDataFunc(ColorID)
                .then(res => {
                    const getcolordata = res?.data?.response
                    Object.keys(initialState).forEach((fieldname) => {
                        setValue(fieldname, getcolordata[`${fieldname}`]);
                    })
                })
        }
    }, [ColorID])

    return (
        <>
            {coloradd &&
                <FormProvider className="tablelist-form" methods={methods} onSubmit={handleSubmit(onSubmit)}>
                    <Row>
                        <div id="alert-error-msg" className="d-none alert alert-danger py-2"></div>
                        <input type="hidden" id="id-field" />
                        <Col lg={12}>
                            <div className="mb-3">
                                <RHFTextField
                                    name='colourGroupName'
                                    label='Color Group Name'
                                    required={true}
                                    value={colourGroupname}
                                />
                            </div>
                        </Col>
                        <Col lg={6}>
                            <div className="mb-3">

                                <RHFTextField
                                    name='name'
                                    label='Color Name'
                                    required={true}
                                    onChange={(e) => {
                                        setValue('name', e.target.value, {
                                            shouldDirty: true,
                                            shouldTouch: true,
                                            shouldValidate: true,
                                        });
                                        setValue('slug', e.target.value.toLowerCase().replace(/\s+/g, '-'), {
                                            shouldDirty: true,
                                            shouldTouch: true,
                                            shouldValidate: true,
                                        });
                                    }}
                                />
                            </div>
                        </Col>
                        <Col lg={6}>
                            <div className="mb-3">

                                <RHFTextField name='slug' label='Slag Url' required={true} />
                            </div>
                        </Col>
                        <Col lg={6}>
                            <div className="mb-3">
                                <RHFTextField name='hexCode' label='Hex Code' onClick={() => { setColorpicker(!colorpicker) }} required={true} />

                                {colorpicker &&
                                    <ColorPicker name='hexCode'
                                        onChange={(e) => {
                                            setValue('hexCode', e.hex, {
                                                shouldDirty: true,
                                                shouldTouch: true,
                                                shouldValidate: true,
                                            });
                                        }}
                                    />
                                }
                            </div>
                        </Col>
                        <Col lg={6}>
                            <div className="mb-3">
                                <RHSelectField
                                    name='status'
                                    label='Color Status'
                                    required={true}
                                    list={[
                                        { name: 'Active', value: true },
                                        { name: 'Inactive', value: false },
                                    ]}
                                />

                            </div>
                        </Col>
                        <Col lg={12} className="modal-footer">
                            <div className="hstack gap-2 justify-content-end">
                                <Button variant='outlined' color='secondary' className='ml-auto' onClick={() => { setColoradd(false) }}>
                                    Cancel
                                </Button>
                                <Button variant='primary' type='submit'>
                                    {ColorID ? 'Update' : 'Save'}
                                </Button>
                            </div>
                        </Col>
                    </Row>
                </FormProvider>}
            {showCoupons &&
                <Offcanvas show={showCoupons} onHide={() => setShowCoupons(!showCoupons)} placement="end">
                    <Offcanvas.Header closeButton>
                        <Offcanvas.Title>Color Details</Offcanvas.Title>
                    </Offcanvas.Header>
                    <Offcanvas.Body>
                        <div className="mt-3">
                            <div className="table-responsive">
                                <div style={{
                                    width: '300px',
                                    height: '200px',
                                    backgroundColor: showCouponDetails.hexCode,
                                    borderRadius: 10,
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center'

                                }}>
                                    {/* You can add other content here if needed */}
                                </div>
                                <table className="table table-borderless">

                                    <tbody><tr>
                                        <td><span className="text-muted">Color Group Name</span></td>
                                        <td><span className="fw-medium">{colourGroupname}</span></td>
                                    </tr>
                                        <tr>
                                            <td><span className="text-muted">Color Name</span></td>
                                            <td><span className="fw-medium">{showCouponDetails.name}
                                            </span></td>
                                        </tr>
                                        <tr>
                                            <td><span className="text-muted">Hex Code </span></td>
                                            <td><span className="fw-medium">{showCouponDetails.hexCode}

                                            </span></td>
                                        </tr>
                                        <tr>
                                            <td><span className="text-muted">Status</span></td>
                                            <td><span className={showCouponDetails.status === false ? "badge bg-danger-subtle text-danger text-uppercase" : "badge bg-success-subtle text-success text-uppercase"}>{showCouponDetails.status ? 'Active' : 'Inactive'}</span></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </Offcanvas.Body>
                </Offcanvas>
            }

        </>
    );
}

export default ColorAdd;
